import SelectionState from "state/selections/SelectionState";
import voca from "voca";
import {
  selectDefinitions,
  selectFetchingTradeTrackingErrorData,
  selectTradeStrategies,
  selectTradeStrategyGroups,
  selectTradeTrackingErrorFields,
} from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const selectedDefinitions = useSelector(
    selectDefinitions(SelectionState.COMMITTED)
  );
  const isFetchingMap = useSelector(selectFetchingTradeTrackingErrorData);
  const tradeStrategyGroups = useSelector(selectTradeStrategyGroups);
  const tradeStrategies = useSelector(selectTradeStrategies);
  const fields = useSelector(selectTradeTrackingErrorFields);
  const dispatch = useDispatch();

  return React.useMemo(() => {
    const strategyGroupDecodeMap = tradeStrategyGroups.reduce(
      (map, strategyGroupDecode) => {
        map[strategyGroupDecode.strategyGroupId] = strategyGroupDecode;
        return map;
      },
      {}
    );
    const tradeStrategyMap = tradeStrategies.reduce((map, tradeStrategy) => {
      map[tradeStrategy.tradeStrategyId] = tradeStrategy;
      return map;
    }, {});
    const getColDef = (field, definition) => {
      const {
        key,
        strategyGroupId,
        tradeStrategyId,
        tradeTrackingErrorType,
        covarianceType,
        summary
      } = definition;
      const strategyGroupEntity = strategyGroupDecodeMap[strategyGroupId] || {};
      const strategyEntity = tradeStrategyMap[tradeStrategyId] || {};
      return {
        headerName: `Trade Tracking Error - ${voca.titleCase(field)} (${strategyGroupEntity.strategyGroupName || strategyGroupId
          } - ${strategyEntity.tradeStrategyName || tradeStrategyId
          } - ${voca.titleCase(tradeTrackingErrorType)} - ${voca.titleCase(
            covarianceType
          )} - ${voca.titleCase(summary)})`,
        colId: `${key},${field}`,
        field: `${key},${field}`,
        loading: isFetchingMap[key],
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };
    };
    return selectedDefinitions.reduce((colDefs, teDefinition) => {
      fields.forEach((field) => {
        colDefs.push(getColDef(field, teDefinition));
      });
      return colDefs;
    }, []);
  }, [
    dispatch,
    fields,
    isFetchingMap,
    selectedDefinitions,
    tradeStrategies,
    tradeStrategyGroups,
  ]);
};
